<!--
  ~ Copyright (c) 2020 Signum+ Software & Facility GmbH
  ~ Author: jahn@signum-plus.at
  -->

<ng-template [ngTemplateOutlet]="model && model.template"></ng-template>
